import { createStore } from 'vuex'
import  cookies from 'vue-cookies'
import router from "@/router";
import jobDescription from "@/store/modules/OrganizationId/jobDescription";
import jobQualification from "@/store/modules/OrganizationId/jobQualification";
import jobProfessionalValues from "@/store/modules/OrganizationId/jobProfessionalValues";
import jobResponsibilities from "@/store/modules/OrganizationId/jobResponsibilities";
import communicationDomain from "@/store/modules/OrganizationId/communicationDomain";
import dutiesDescription from "@/store/modules/OrganizationId/dutiesDescription";
import competencies from "./modules/OrganizationId/competenciesKnowledge";
import abilities from "././modules/OrganizationId/competenciesAbility";
import skills from "././modules/OrganizationId/competenciesSkill";
import courses from "././modules/OrganizationId/competencyCourses";
import rules from "././modules/OrganizationId/rules";
import powers from "././modules/OrganizationId/powers";
import responsibilityHierarchy from "././modules/OrganizationId/responsibilityHierarchy";
import jobProtectionClassification from "././modules/OrganizationId/jobProtectionClassification";
import suppliers from "././modules/OrganizationId/suppliers";
import crudActions from "././modules/OrganizationId/crudActions";
import generalModules from './modules/generalModules';

import jobDescriptionModules from './modules/jobDescriptionModules';

import strategicPlanningModules from './modules/strategicPlanningModules';
import riskCharter from './modules/riskManagementModules/riskCharter';
import riskPolicy from './modules/riskManagementModules/riskPolicy';
import riskStatement from './modules/riskManagementModules/riskStatement';


export default createStore({
  state: {
    isAuth: false,
    token: '',
    statusInformation: false,
    is_show: true, // وضعیت کلی نمایش مسیرها
    executive_element: false, // وضعیت کلی نمایش مسیرها
    menu: false // منوی کاربری
  },
  getters: {
    // می‌توانید getters ایجاد کنید اگر نیاز به دسترسی خاص به state دارید
  },
  mutations: {
    onStart(state) {
      const token = cookies.get('token');
      if (token) {
        state.isAuth = true;
        state.token = token;
      } else {
        state.isAuth = false;
        state.token = '';
      }
    },
    login(state, token) {
      if (token) {
        state.isAuth = true;
        state.token = token;
        cookies.set('token', token, "3y");
      } else {
        state.isAuth = false;
        state.token = '';
        cookies.remove('token');
      }
    },
    logout(state) {
      state.isAuth = false;
      state.token = '';
      cookies.remove('token');
      cookies.remove('is_mother');
      cookies.remove('type_3');
      cookies.remove('type_2');
      cookies.remove('type_1');
      cookies.remove('mother_mode');
      cookies.remove('id_login');
      router.push('/');
    },
    setSharedList(state, newList) {
      state.statusInformation = newList;
      setTimeout(() => {
        if (state.statusInformation) {
          state.statusInformation = false;
        }
      }, 1000);
    },
    setIsShow(state, value) {
      state.is_show = value;
    },
    setExecutiveElement(state, value) {
      state.executive_element = value;
    },
    // اضافه کردن mutation برای آپدیت منو
    setMenu(state, menuData) {
      state.menu = menuData;
    }
  },
  actions: {
    updateIsShow({ commit }, value) {
      commit('setIsShow', value);
    },
    // اضافه کردن اکشن برای آپدیت منو
    updateMenu({ commit }, menuData) {
      commit('setMenu', menuData);
    }
  },
  modules: {
    jobDescription,
    jobQualification,
    jobProfessionalValues,
    jobResponsibilities,
    communicationDomain,
    dutiesDescription,
    competencies,
    abilities,
    skills,
    courses,
    rules,
    powers,
    responsibilityHierarchy,
    jobProtectionClassification,
    suppliers,
    crudActions,
    ...generalModules,
    ...jobDescriptionModules,
    ...strategicPlanningModules,
    riskCharter,
    riskPolicy,
    riskStatement,
  }
});
